import * as React from 'react';
import styled from '@emotion/styled';

import { controlBase, errorRing } from './_mixins';
import { Icon, type IconName } from './Icon';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
  /** Optional leading icon. */
  icon?: IconName;
}

const Field = styled.input<{ $error?: boolean; $hasIcon?: boolean }>`
  ${({ theme }) => controlBase(theme)}
  ${({ theme, $error }) => $error && errorRing(theme)}
  ${({ $hasIcon }) => $hasIcon && 'padding-left: 34px;'}
`;

const Group = styled.span`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
`;

const LeadingIcon = styled(Icon)`
  position: absolute;
  left: 10px;
  color: ${({ theme }) => theme.color.fg.subtle};
  pointer-events: none;
`;

/** Lumen text input — optional leading icon + error state. */
export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  function Input({ error, icon, ...rest }, ref) {
    if (!icon) return <Field ref={ref} $error={error} {...rest} />;
    return (
      <Group>
        <LeadingIcon name={icon} size={16} />
        <Field ref={ref} $error={error} $hasIcon {...rest} />
      </Group>
    );
  }
);
